import styles from "./AddMemberModal.module.css";

import React, { useEffect, useState } from "react";
import { Button, Modal, Select } from "antd";
import styled from "@emotion/styled";
import useNotification from "../../../../../../hooks/useNotification";
import EnterpriseServices from "../../../../../../services/EnterpriseServices";
import JobServices from "../../../../../../services/JobServices";

const CustomModal = styled(Modal)`
  //   && .ant-modal-footer > button:nth-child(2) {
  //     background-color: #b2da66;
  //     border-color: #d9d9d9;
  //     color: white;
  //     box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
  //     font-size: 16px;
  //     padding: 0px 30px;
  //   }

  && .ant-modal-title {
    font-size: 14px;
  }

  && .ant-modal-footer > button {
    height: 37px;
  }
`;

const testoptions = [
  {
    value: "1",
    label: "Jack",
  },
  {
    value: "2",
    label: "Lucy",
  },
  {
    value: "3",
    label: "Tom",
  },
];

const AddMemberModal = ({ data, onSubmit }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [value, setValue] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();
  const [options, setOptions] = useState([]);
  const [memberData, setMemberData] = useState([]);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = async () => {
    if (value.length > 0) {
      setLoading(true);
      try {
        const jobData = {
          jobId: data._id,
          team_members: value,
        };

        const res = await JobServices.UpdateJob(jobData);

        if (res) {
          if (res.statusCode === 1) {
            showNotification("Job status updated successfuly");
            setIsModalOpen(false);
            onSubmit();
          } else {
            handleError(`${res.statusDesc}`);
          }
        } else {
          handleError(`Error: ${res.statusDesc}`);
        }
      } catch (error) {
        console.log(error);
        if (error.statusCode === 0) {
          console.log("Error while updating info", error);
          handleError(error.description);
        } else {
          handleError("Error: Member info is not updated.");
        }
      }
      setLoading(false);
    } else {
      handleError("Please select member");
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchMembersList = async () => {
    try {
      const res = await EnterpriseServices.getMembersByJob(
        data._id,
        "drop=true"
      );
      if (res) {
        if (res.statusCode === 1) {
          setMemberData(res.data);
          setOptions(
            (res.data || []).map((item) => {
              return {
                label: item.firstName + " " + item.lastName,
                value: item._id,
              };
            })
          );
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while fetching info", error);
        handleError(error.description);
      } else {
        handleError("Error: Member not found.");
      }
    }
  };

  useEffect(() => {
    if (data._id) {
      fetchMembersList();
    }
  }, [data._id, isModalOpen]);

  const handleError = (error) => {
    // setLoading(false);
    showNotification(error, "error");
  };

  const handleDropChange = (e) => {
    console.log("value", value);
    const selectedObject = memberData.find((obj) => obj._id === e);
    if (selectedObject) {
      const updatedTeamMembers = [...value, selectedObject];
      setValue(updatedTeamMembers);
    }
  };

  const handleRemoveDrop = (e) => {
    const indexToRemove = value.findIndex((obj) => obj._id === e);
    if (indexToRemove !== -1) {
      const updatedTeamMembers = [...value];
      updatedTeamMembers.splice(indexToRemove, 1);
      setValue(updatedTeamMembers);
    }
  };
  return (
    <>
      <div className={styles.add_button_bar}>
        <button onClick={showModal}>Add Member</button>
      </div>
      <CustomModal
        title="ADD INTERVIEW MEMBERS"
        open={isModalOpen}
        onOk={handleOk}
        loading={loading}
        onCancel={handleCancel}
        okText={"Update"}
        okButtonProps={{
          disabled: !value,
        }}
      >
        <div className={styles.modal_content}>
          <Select
            showSearch
            style={{ width: "100%" }}
            size="large"
            placeholder="Invite Members"
            onChange={setValue}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            onSelect={handleDropChange}
            onDeselect={handleRemoveDrop}
            mode="multiple"
            options={options}
          />
        </div>
      </CustomModal>
    </>
  );
};

export default AddMemberModal;
